"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import { FaMapMarkerAlt } from "react-icons/fa";
import { localEventsTranslations } from '@/lib/pagesTranslations'

type Event = {
  time: string;
  type: string;
  title: string;
  location: string;
  locationUrl: string | null;
  price: string;
  dateRange: string;
  color: string;
};

const events: Event[] = [
];

export default function LocalEventsList() {
  const pathname = usePathname();
  const locale = pathname?.startsWith("/en") ? "en" : "pt";
  const t = localEventsTranslations[locale] ?? localEventsTranslations["pt"];

  return (
    <section className="text-[#1B475D]">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-xl font-bold mb-6">{t.heading}</h2>

        <div className="bg-white text-[#1B2D22] rounded-2xl shadow-lg p-6 space-y-6">
          {events.length === 0 ? (
            <div className="text-center py-12 text-[#1B475D]">
              <p className="text-lg font-semibold mb-2">{t.noEventsTitle}</p>
              <p className="text-sm text-[#1B475D]/70">{t.noEventsSubtitle}</p>
            </div>
          ) : (
            events?.map((event, index) => (
              <div
                key={index}
                className="flex flex-col md:flex-row md:items-center md:justify-between gap-6 border-b last:border-b-0 pb-8 last:pb-0"
              >
                {/* Time */}
                <div className="text-base font-semibold w-auto md:w-24">
                  {event.time}
                </div>

                {/* Color bar + details */}
                <div className="flex gap-4 items-start md:flex-1">
                  <div className={`w-1 h-14 rounded-full ${event.color}`} />
                  <div>
                    <div className="text-sm text-gray-500">{event.type}</div>
                    <div className="text-lg font-semibold text-[#1B475D]">
                      {event.title}
                    </div>
                  </div>
                </div>

                {/* Metadata */}
                <div className="flex flex-col items-start gap-2 md:flex-row md:items-center md:justify-end md:gap-6 text-sm">
                  <Link
                    className="flex items-center gap-2 text-[#1B475D]"
                    href={event?.locationUrl ?? "#"}
                    target="_blank"
                    rel="noopener noreferrer nofollow"
                  >
                    <FaMapMarkerAlt size={16} className="text-[#8EBD9D]" />
                    <span className="text-sm text-[#1B475D]">{event.location}</span>
                  </Link>

                  <span className="text-sm text-[#1B475D]">{event.price}</span>
                  <span className="text-sm text-gray-500">{event.dateRange}</span>
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </section>
  );
}
